import {
  ACCOUNTING_METHODS,
  TAX_YEAR_END,
  STRIPE_FREQUENCY,
} from "./bookkeeping";

export const BOOKS_SETTINGS_TABS = {
  ACCOUNTING: "accounting",
  RULES: "rules",
  DEFAULT_CATEGORIES: "default-categories",
  CLASSIFICATIONS: "classifications",
  INVOICES: "invoices",
  BILLS: "bills",
  CUSTOM_REPORTS: "custom-reports",
  CHART_OF_ACCOUNTS: "chart-of-accounts",
} as const;

export type BooksSettingsTabType =
  (typeof BOOKS_SETTINGS_TABS)[keyof typeof BOOKS_SETTINGS_TABS];

export const BOOKS_SETTINGS_TAB_LABELS = {
  [BOOKS_SETTINGS_TABS.ACCOUNTING]: "Accounting",
  [BOOKS_SETTINGS_TABS.RULES]: "Rules",
  [BOOKS_SETTINGS_TABS.DEFAULT_CATEGORIES]: "Default Categories",
  [BOOKS_SETTINGS_TABS.CLASSIFICATIONS]: "Classifications",
  [BOOKS_SETTINGS_TABS.INVOICES]: "Invoices",
  [BOOKS_SETTINGS_TABS.BILLS]: "Bills",
  [BOOKS_SETTINGS_TABS.CUSTOM_REPORTS]: "Custom Reports",
  [BOOKS_SETTINGS_TABS.CHART_OF_ACCOUNTS]: "Chart of Accounts",
} as const;

export const ACCOUNTING_METHOD_OPTIONS = [
  {
    label: "Accrual",
    value: ACCOUNTING_METHODS.ACCRUAL,
  },
  {
    label: "Cash",
    value: ACCOUNTING_METHODS.CASH,
  },
];

export const TAX_YEAR_OPTIONS = [
  { label: "January", value: TAX_YEAR_END.FEB_JAN },
  { label: "February", value: TAX_YEAR_END.MAR_FEB },
  { label: "March", value: TAX_YEAR_END.APR_MAR },
  { label: "April", value: TAX_YEAR_END.MAY_APR },
  { label: "May", value: TAX_YEAR_END.JUN_MAY },
  { label: "June", value: TAX_YEAR_END.JUL_JUN },
  { label: "July", value: TAX_YEAR_END.AUG_JUL },
  { label: "August", value: TAX_YEAR_END.SEP_AUG },
  { label: "September", value: TAX_YEAR_END.OCT_SEP },
  { label: "October", value: TAX_YEAR_END.NOV_OCT },
  { label: "November", value: TAX_YEAR_END.DEC_NOV },
  { label: "December", value: TAX_YEAR_END.JAN_DEC },
];

export const STRIPE_FREQUENCY_OPTIONS = [
  {
    label: "Daily",
    value: STRIPE_FREQUENCY.DAILY,
  },
  {
    label: "Monthly",
    value: STRIPE_FREQUENCY.MONTHLY,
  },
];

export const DEFAULT_CATEGORIES_SECTIONS = {
  PAYROLL: "PAYROLL",
  REVENUE: "REVENUE",
  STRIPE: "STRIPE",
  EXPENSE: "EXPENSE",
  MULTICURRENCY: "MULTICURRENCY",
  ADJUSTMENTS: "ADJUSTMENTS",
} as const;

export const SECTION_LABELS = {
  [DEFAULT_CATEGORIES_SECTIONS.PAYROLL]: "Payroll",
  [DEFAULT_CATEGORIES_SECTIONS.REVENUE]: "Revenue",
  [DEFAULT_CATEGORIES_SECTIONS.STRIPE]: "Stripe",
  [DEFAULT_CATEGORIES_SECTIONS.EXPENSE]: "Expense",
  [DEFAULT_CATEGORIES_SECTIONS.MULTICURRENCY]: "Multi-currency",
  [DEFAULT_CATEGORIES_SECTIONS.ADJUSTMENTS]: "Adjustments",
};

export const SECTION_ORDER = [
  DEFAULT_CATEGORIES_SECTIONS.REVENUE,
  DEFAULT_CATEGORIES_SECTIONS.STRIPE,
  DEFAULT_CATEGORIES_SECTIONS.EXPENSE,
  DEFAULT_CATEGORIES_SECTIONS.MULTICURRENCY,
  DEFAULT_CATEGORIES_SECTIONS.ADJUSTMENTS,
  DEFAULT_CATEGORIES_SECTIONS.PAYROLL,
];
